import APIClient from '@/shared/http/clients/api'
import APIClientUpload from '@/shared/http/clients/apiupload'

const resourceName = 'importregulationauto'
const APIRegAuto = process.env.APIBaseURLRegulationAuto

const Validate = (data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}/validate`, data, config)
const Import = (data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}`, data, config)
const GetByDate = (data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}/date`, data, config)
const ImportTokio = (data = {}, config = {}) => APIClientUpload.post(`${APIRegAuto}/${resourceName}/ImportTokio`, data, config)

const ImportRegulationAutoRepository = {
  Validate,
  Import,
  GetByDate,
  ImportTokio
}

export default ImportRegulationAutoRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/regulation/imports/importregulationauto.js